import { parsePhoneNumberFromString } from "libphonenumber-js/min";
import * as React from "react";

import { Link } from "../components";

// eslint-disable-next-line max-len
const linkMatchPattern = /(?:(?:http|https|ftp):\/\/)(?:localhost|(?:(?:[a-z\u00a1-\uffff0-9][-_]*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,}))?)(?::\d{2,5})?(?:[/?#][^\s"]*)?/gi;

const highlightPattern = (text, pattern) => {
    if (!text) return "";

    const splitText = text.split(pattern);

    if (splitText.length <= 1) {
        return text;
    }

    const matches = text.match(pattern);

    const t = splitText.reduce((arr, element, index) => {
        const href = matches[index];
        if (href) {
            return [
                ...arr,
                element,
                React.createElement(
                    Link,
                    {
                        target: "_blank",
                        href: matches[index],
                        highlightType: "external",
                    },
                    matches[index]
                ),
            ];
        } else {
            return [...arr, element];
        }
    }, []);
    return t;
};

export const textWithLinks = (text: string) =>
    highlightPattern(text, linkMatchPattern);

export const formatPhoneText = (phone: string): string => {
    if (!phone) return "";
    if (!phone.startsWith("+1")) phone = "+1" + phone;
    const phoneNumber = parsePhoneNumberFromString(phone);
    return phoneNumber.formatNational();
};
